<template>
  <div>
    <Label v-if="required">{{ label }} <span class="text-danger">*</span></Label>
    <label v-else class="form-control-label">{{ label }}</label>
    <multiselect
      v-model="selectedAnosafra"
      :options="anosafras"
      placeholder="Selecionar o Ano Safra"
      label="descricao"
      :selected-label="'Selecionado'"
      :loading="loading"
      @search-change="debouncedGetAnosafras"
      @bottom-reached="debouncedGetAnosafras"
      :multiple="multiple"
      track-by="id"
      :limit="1"
      :limit-text="limitText"
      :close-on-select="closeOnSelect"
      open-direction="bottom"
      @input="onChange"
      class="anosafra-multiselect"
    >
      <template 
        v-if="multiple === true" 
        slot="beforeList"
      >
        <div 
          @click="toggleSelectAll" 
          :class="allSelected ? 'all-selected' : 'multiple select-all-option'"  
          :style="allSelected ? 'background-color: #e9ecef; color: #212529' : ''"
        >
          <span 
            :style="allSelected ? 'font-weight: 700' : ''"
          >
            {{ allSelected ? 'desmarcar todos' : 'selecionar todos' }}
          </span>
        </div>
      </template>
      <template v-for="(_, name) in $scopedSlots" v-slot:[name]="scope">
        <slot :name="name" v-bind="scope" />
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";

export default {
  name: 'AnosafraMultiselect',
  components: {
    Multiselect,
  },
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      default: 'Ano Safra',
    },
    apiVersion: {
      type: String,
      default: 'v1',
    },
    filter: {
      type: [String, Object],
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      anosafras: [],
      loading: false,
      pagination: {
        page: 1,
        per_page: 10,
      },
      getAnosafrasTimeout: null,
      allSelectedActive: false,
      totalAnosafras: null,
      totalCounter: 0,
      lastAnosafraQuery: null,
    };
  },
  mounted() {
    this.getAnosafras();
  },
  methods: {
    async getAnosafras(query = null) {
      this.loading = true;
      let versionApi = '', q = null;

      const requestParams = {
        page: this.pagination.page,
        per_page: this.pagination.per_page,
      }

      if (query && query.length > 0)  {
        q = {}
        q.name = query
      }

      if (this.lastAnosafraQuery != query) this.pagination.page = 1;
      if (this.apiVersion === 'v1')     versionApi = '/api/v1';
      if (this.apiVersion === 'v2')     versionApi = '/api/v2';
      if (q)                            requestParams.q = q;

      try {
        const response = await this.$http.secured.get(`${versionApi}/anosafras`, {
          params: requestParams
        });
        
        const initialAnosafras = response.data.anosafras || response.data.data || [];
        const newAnosafras = initialAnosafras.sort((a, b) => a.descricao.localeCompare(b.descricao));

        const currentAnosafra = this.$store.state.currentAnosafra;

        if (currentAnosafra && Object.keys(currentAnosafra).length) {
        this.selectedAnosafra = [currentAnosafra];
        } else if (this.anosafras.length > 0) {
        this.selectedAnosafra = [this.anosafras[0]];
        }

        if (!this.totalAnosafras) this.totalAnosafras = response.data.count;

        if (this.pagination.page === 1) {
          this.anosafras = newAnosafras;

          if (this.allSelectedActive) this.selectedAnosafra = newAnosafras;
        } else {
          const uniqueAnosafras = newAnosafras.filter(newBrand => !this.anosafras.some(anosafra => anosafra.id === newBrand.id));
          this.anosafras = [...this.anosafras, ...uniqueAnosafras];

          if (this.allSelectedActive) this.selectedAnosafra = [...new Set([...this.selectedAnosafra, ...newAnosafras])];
        }
        this.pagination.page += 1;
        this.lastAnosafraQuery = query;
      } catch (error) {
        console.error('[AnosafraMultiselect][getAnosafras]', error);
      } finally {
        this.loading = false;
      }
    },
    debouncedGetAnosafras(query) {
      if (this.getAnosafrasTimeout) clearTimeout(this.getAnosafrasTimeout);

      this.getAnosafrasTimeout = setTimeout(
        () => this.getAnosafras(query),
        700
      );
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedAnosafra = [];
        this.allSelectedActive = false;
      } else {
        this.selectedAnosafra = [...this.anosafras];
        this.allSelectedActive = true;
      }
    },
    limitText(count) { 
      if (this.allSelectedActive){
        this.totalCounter = this.totalAnosafras - this.deselectedFromAll.length - 1;
      } else {
        this.totalCounter = count;
      }
      return `+ ${this.totalCounter}`;
    },
    clear() {
      this.selectedAnosafra = []
    },
    onChange(value) {
      const formattedValue = this.multiple
        ? (Array.isArray(value) ? value : [])
        : (Array.isArray(value) ? value[0] : value);

      this.$emit('input', formattedValue);
    }
  },
  computed: {
    deselectedFromAll() {
      if (!this.allSelectedActive) return [];

      return this.anosafras.filter(anosafra => !this.selectedAnosafra.some(selectedAnosafra => selectedAnosafra.id == anosafra.id));
    },
    allSelected() {
      if (this.allSelectedActive && !this.anosafras.length) return true;

      return (
        this.anosafras.length &&
        this.selectedAnosafra.length === this.anosafras.length
      );
    },
    selectedAnosafra: {
      get() {
        if (this.multiple) {
          if (Array.isArray(this.value)) return this.value;
          if (this.value && typeof this.value === 'object') return [this.value];
          return [];
        } else {
          if (this.value && typeof this.value === 'object') return this.value;
          return null;
        }
      },
      set(value) {
        if (this.multiple) {
          if (Array.isArray(value)) {
            this.$emit('input', value);
          } else if (value && typeof value === 'object') {
            this.$emit('input', [value]);
          } else {
            this.$emit('input', []);
          }
        } else {
          if (Array.isArray(value)) {
            this.$emit('input', value[0] || null);
          } else if (value && typeof value === 'object') {
            this.$emit('input', value);
          } else {
            this.$emit('input', null);
          }
        }
      }
    },
  }
};
</script>
<style scoped>
.anosafra-multiselect :deep .multiselect__single {
  position: relative;
  display: inline-block;
  padding: 4px 8px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #41b883;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  width: fit-content;
  max-width: 90%;
  font-size: 14px;
  text-overflow: ellipsis;
}

.multiple {
  cursor: pointer;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.multiple:hover {
  background-color: #41b883;
  color: white;
}
.multiselect__option--highlight {
  background-color: transparent !important;
  color: #35495e;
}
.multiselect__option--selected.multiselect__option--highlight {
  background-color: rgb(239, 241, 244) !important;
  color: #35495e;
}
.multiselect__option:hover {
  background-color: #41b883  !important; 
  color: white;
}
.all-selected:hover {
  background-color: #41b883  !important; 
  color: white;
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.all-selected {
  height: 30px;
  padding: 12px 10px 30px 12px;
  cursor: pointer;
}
</style>